// const playlist =  [{"videoId":"9jK-NcRmVcw","range":"0:13-4:30","title":"The Final Countdown","artist":"Europe","intervals":["0:51-1:20","1:57-2:15","2:47-3:50"]}]

// const playlist =  [{
//   "videoId":"9jK-NcRmVcw","range":"0:13-0:23","title":"The Final Countdown","artist":"Europe","intervals":["0:17-0:20"]
// }, {
//   "videoId":"JRfuAukYTKg","range":"0:13-0:23","title":"Titanium","artist":"David Guetta","intervals":["0:17-0:20"]
// }
// ]


const playlist =  [ {
      "artist" : "Europe",
      "intervals" : [ "0:51-1:20", "1:57-2:15", "2:47-3:50" ],
      "range" : "0:13-4:30",
      "title" : "The Final Countdown",
      "videoId" : "9jK-NcRmVcw"
    }, {
      "artist" : "David Guetta",
      "intervals" : [ "1:15-2:00", "2:30-2:55", "3:15-3:50" ],
      "range" : "0:30-3:50",
      "title" : "Titanium",
      "videoId" : "JRfuAukYTKg"
    }, {
      "artist" : "Florence + The Machine",
      "intervals" : [ "1:06-1:36", "2:05-2:35", "2:51-3:30" ],
      "range" : "0:28-3:44",
      "title" : "Dog Days Are Over",
      "videoId" : "iWOyfLBYtuU"
    }, {
      "artist" : "Haddaway",
      "intervals" : [ "0:22-0:52", "1:28-2:00", "2:38-3:38" ],
      "range" : "0:00-3:10",
      "title" : "What is Love",
      "videoId" : "HEXWRTEbj1I"
    }, {
      "artist" : "Flo Rida",
      "intervals" : [ "0:31-1:01", "1:24-1:54", "2:10-2:40" ],
      "range" : "0:00-3:01",
      "title" : "Wild ones Ft. Sia",
      "videoId" : "bpOR_HuHRNs"
    }, {
      "artist" : "Darude",
      "intervals" : [ "0:31-1:14", "2:30-3:14" ],
      "range" : "0:00-3:40",
      "title" : "Sandstorm",
      "videoId" : "y6120QOlsfU"
    }, {
      "artist" : "Kygo",
      "intervals" : [ "0:30-1:00", "1:19-1:49", "2:18-2:48", "3:01-3:31" ],
      "range" : "0:00-3:46",
      "title" : "Remind Me to Forget",
      "videoId" : "FRjOSmc01-M"
    }, {
      "artist" : "Meduza",
      "intervals" : [ "0:39-1:19", "1:55-2:35"],
      "range" : "0:00-2:47",
      "title" : "Lose Control",
      "videoId" : "b7kxtIGaNpw"
    }, {
      "artist" : "Beyoncé",
      "intervals" : [ "0:30-1:05", "1:29-2:00", "2:45-3:30"],
      "range" : "0:00-3:55",
      "title" : "Crazy In Love ft. JAY Z",
      "videoId" : "ViwtNLUqkMY"
    }, {
      "artist" : "Lady Gaga",
      "intervals" : [ "0:00-0:30", "0:58-1:28", "1:53-2:23"],
      "range" : "0:00-3:25",
      "title" : "Poker Face",
      "videoId" : "bESGLojNYSo"
    } , {
      "artist" : "Billie Eilish",
      "intervals" : [ "0:56-1:30", "2:00-2:30", "3:00-3:25"],
      "range" : "0:15-3:25",
      "title" : "Bad Guy",
      "videoId" : "DyDfgMOUjCI"
    }
                  ]
export default playlist
